export default "/assets/font_family_proxima_nova-51bbbf1bdb6397c44f0e0e0d03c57f3c9e64c0338e7e156432ac5d92a89a89c3.svg";